import React from 'react'
import "./Obp.css"
import Button from 'react-bootstrap/Button';

const Obp = () => {
  return (
    <div>
      <div className="section9">
          <div className="container9">
          <h1>Our Best Products</h1>
            <div className="content-section9">
                
              <div className="content9">
                <br></br>
                {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3> */}
                <p>Our products are characterized by quality, sustainability, and innovation, reflecting our commitment to excellence and the environment.</p>
                <br></br>
                <Button variant="outline-dark"><a href="/Products">VIEW MORE</a></Button>
                
                <div className="image-section10">
                <br></br>
              {/* <img src="/images/47.jpg" alt="" />
              <h3>Fibc Bags</h3> */}
            </div>
                {/* <div className="button">
                  <a href="">Read More</a>
                </div> */}
              </div>
              <div className="title9">
              {/* <h3>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Excepturi quasi odio, numquam fugiat illum similique!</h3>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Deserunt inventore vitae doloremque dolore ut iusto recusandae beatae esse mollitia voluptate optio atque totam autem non blanditiis, odit commodi ullam repellat.</p> */}
               <div className="image-section11">
              <img src="/images/46.jpg" alt="" />
              <h3>PP Woven sack Bags</h3>
            </div>
              </div>
            
            </div>
            
            <div className="image-section9">
              <img src="/images/28.jpg" alt="" />
              <br></br><br></br>
              <h3>PP Woven Fabric</h3>
            </div>
          </div>
        </div>
    </div>
  )
}

export default Obp
